import EnvironmentSettings from "../../Classes/Models/EnvironmentSettings";
import UsersApi from "./UsersApi";
import TenantManager from "./TenantManager";

class BuildingApi {
  constructor() {
    this.baseUrl =
      EnvironmentSettings.Environment === "dev"
        ? EnvironmentSettings.LocalUrl
        : EnvironmentSettings.LiveUrl;
  }

  //============================= URls ============================//
  BuildingUrl = "Building/";

  //============================= Private Helper ============================//
  async getHeaders() {
    const token = await UsersApi.GetToken();
    return {
      Authorization: `Bearer ${token}`,
      tenant: TenantManager.getTenant(token),
      "Content-Type": "application/json",
    };
  }

  //============================= Methods ============================//

  async CreateBuilding(payload) {
    const res = await fetch(this.baseUrl + this.BuildingUrl, {
      method: "POST",
      headers: await this.getHeaders(),
      body: JSON.stringify(payload),
    });

    const data = await res.json();
    return data;
  }

  async GetBuildings(payload) {
    const res = await fetch(this.baseUrl + this.BuildingUrl + "GetAll", {
      method: "POST",
      headers: await this.getHeaders(),
      body: JSON.stringify(payload),
    });

    const data = await res.json();
    return data;
  }

  async UpdateBuilding(id, payload) {
    const res = await fetch(this.baseUrl + this.BuildingUrl + id, {
      method: "PUT",
      headers: await this.getHeaders(),
      body: JSON.stringify(payload),
    });

    const data = await res.json();
    return data;
  }
}

export default new BuildingApi();
